// src/Redux/Slice/homeSlice.js
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const homeSlice = createSlice({
  name: "home",
  initialState: {
    slider: {
      images: [],
      loading: false,
      error: null,
    },
    welcome: {
      data: [],
      loading: false,
      error: null,
    },
    partners: {
      images: [],
      loading: false,
      error: null,
    },
    gallery: {
      data: [],
      loading: false,
      error: null,
    },
    popup: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    // Slider Reducers
    fetchSliderStart(state) {
      state.slider.loading = true;
      state.slider.error = null;
    },
    fetchSliderSuccess(state, action) {
      state.slider.loading = false;
      state.slider.images = action.payload;
    },
    fetchSliderFailure(state, action) {
      state.slider.loading = false;
      state.slider.error = action.payload;
    },

    // Welcome Section Reducers
    fetchWelcomeStart(state) {
      state.welcome.loading = true;
      state.welcome.error = null;
    },
    fetchWelcomeSuccess(state, action) {
      state.welcome.loading = false;
      state.welcome.data = action.payload;
    },
    fetchWelcomeFailure(state, action) {
      state.welcome.loading = false;
      state.welcome.error = action.payload;
    },

    //partner Reducer
    fetchPartnersStart(state) {
      state.partners.loading = true;
      state.partners.error = null;
    },
    fetchPartnersSuccess(state, action) {
      state.partners.loading = false;
      state.partners.images = action.payload;
    },
    fetchPartnersFailure(state, action) {
      state.partners.loading = false;
      state.partners.error = action.payload;
    },

    fetchGalleryStart(state) {
      state.gallery.loading = true;
      state.gallery.error = null;
    },
    fetchGallerySuccess(state, action) {
      console.log("Gallery Success Payload:", action.payload);
      state.gallery.loading = false;
      state.gallery.data = action.payload;
    },
    fetchGalleryFailure(state, action) {
      state.gallery.loading = false;
      state.gallery.error = action.payload;
    },

    fetchPopupStart(state) {
      state.popup.loading = true;
      state.popup.error = null;
    },
    fetchPopupSuccess(state, action) {
      console.log("Gallery Success Payload:", action.payload);
      state.popup.loading = false;
      state.popup.data = action.payload;
    },
    fetchPopupFailure(state, action) {
      state.popup.loading = false;
      state.popup.error = action.payload;
    },
  },
});

export const {
  fetchPopupStart,
  fetchPopupSuccess,
  fetchPopupFailure,
  fetchSliderStart,
  fetchSliderSuccess,
  fetchSliderFailure,
  fetchWelcomeStart,
  fetchWelcomeSuccess,
  fetchWelcomeFailure,
  fetchPartnersStart,
  fetchPartnersSuccess,
  fetchPartnersFailure,
  fetchGalleryStart,
  fetchGallerySuccess,
  fetchGalleryFailure,
} = homeSlice.actions;



export const fetchPopupImage = () => async (dispatch) => {
  dispatch(fetchPopupStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/homePage/getPopUpImage`
    );
    if (response.data.success) {
      dispatch(fetchPopupSuccess(response.data.data));
    } else {
      dispatch(fetchPopupFailure("Failed to fetch popup images"));
    }
  } catch (error) {
    dispatch(fetchPopupFailure(error.message || "Something went wrong"));
  }
};
// Thunk to fetch slider data
export const fetchSliderImages = () => async (dispatch) => {
  dispatch(fetchSliderStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/homePage/getSliderManagement`
    );
    if (response.data.success) {
      dispatch(fetchSliderSuccess(response.data.data));
    } else {
      dispatch(fetchSliderFailure("Failed to fetch slider images"));
    }
  } catch (error) {
    dispatch(fetchSliderFailure(error.message || "Something went wrong"));
  }
};

// Thunk to fetch welcome section data
export const fetchWelcomeData = () => async (dispatch) => {
  dispatch(fetchWelcomeStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/homePage/getWelcomeSection`
    );
    const data = response.data.data[0] || {}; // Default to empty object if no data

    // Dispatch success with the data
    dispatch(
      fetchWelcomeSuccess({
        welcome_message: data.welcome_message || "",
        graduates: data.graduates || 0,
        faculty_members: data.faculty_members || 0,
        employability_rate: data.employability_rate || "",
        years_of_excellence: data.years_of_excellence || 0,
      })
    );
  } catch (error) {
    dispatch(fetchWelcomeFailure(error.message));
  }
};

export const fetchPartnersImages = () => async (dispatch) => {
  dispatch(fetchPartnersStart());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/homePage/getPartner`
    );
    if (response.data.success) {
      dispatch(fetchPartnersSuccess(response.data.data));
    } else {
      dispatch(fetchPartnersFailure("Failed to fetch Partner images"));
    }
  } catch (error) {
    dispatch(fetchPartnersFailure(error.message || "Something went wrong"));
  }
};

export const fetchGalleryData = () => async (dispatch) => {
  dispatch(fetchGalleryStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/homePage/getAlbum`
    );
    console.log("API Response:", response.data); // Debug log
    const data = response.data.data || [];
    dispatch(fetchGallerySuccess(data));
  } catch (error) {
    console.error("API Error:", error);
    dispatch(fetchGalleryFailure(error.message || "Something went wrong"));
  }
  
};

export default homeSlice.reducer;
